<div class="school-subjects-filter" [ngClass]="['school-subjects-filter--layout-' + itemsPerRow]">
  <button role="button" class="school-subjects-filter__item" [ngClass]="{'active': filterItem.active}" *ngFor="let filterItem of options" (click)="toggleFilter(filterItem)">
    <img [src]="filterItem.icon" alt="" aria-hidden="true">
    <span [innerHTML]="filterItem.title"></span>
  </button>
</div>
